import { RiArrowDownCircleFill, RiArrowUpCircleFill } from '@remixicon/react';
import {
	choosePlatform,
	getCoordinatesForPosition,
	getLastOrFirstName,
	shouldRenderFullField,
} from '../../../helpers/utils';
import { DraftPosition } from '../../../types/types';
import { Captain } from '../../Icons/Captain';
import Tooltip from '../../Tooltip';
import { BaskteballField } from './sportField/baskteball';
import { FootballField } from './sportField/football';
import { SoccerField } from './sportField/soccer';

interface iProps {
	positions: DraftPosition[];
	draftResult: any;
	modalityName: string;
}

export const PlantelViewResult = ({
	positions,
	draftResult,
	modalityName,
}: iProps) => {
	const renderField = shouldRenderFullField(positions);
	const getBackgroundStyle = (selectedPlayer: any) => {
		if (!selectedPlayer) return {};
		return {
			backgroundColor: '#FFFF',
			backgroundImage: `url(${selectedPlayer.team.image})`,
			backgroundSize: 'contain',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
		};
	};

	const positionRender = positions.map((pos) => {
		return [...Array(pos.quantity)].map((_, index) => {
			const key = `${pos.position}-${index + 1}`;
			const coords = getCoordinatesForPosition(
				pos.position,
				index,
				pos.quantity,
				renderField
			);
			const selectedPlayer = draftResult.find(
				(item: any) => item.key === key && !item.isReserve
			);

			const scoutsPoints = selectedPlayer && selectedPlayer.scoutsPoints;
			const scouts =
				selectedPlayer &&
				selectedPlayer.scouts.filter((i: any) => i.points !== 0);
			return (
				<Tooltip
					icon={
						<div
							key={key}
							className="absolute flex flex-col items-center"
							style={{
								top: coords.top,
								left: coords.left,
								transform: 'translate(-50%, -50%)',
							}}
						>
							<span className="mb-1.5 font-bahnschrift text-center text-black text-xs font-normal leading-none">
								{scoutsPoints === 0
									? `${scoutsPoints} pts`
									: `${scoutsPoints} pts`}
							</span>

							<div
								className={
									'relative border-2 w-12 h-12 rounded-full font-bahnschrift shadow-md flex items-center justify-center cursor-pointer ' +
									(selectedPlayer
										? 'text-xs bg-primary border-white text-white'
										: 'text-2xl bg-white border-primary text-primary')
								}
								style={getBackgroundStyle(selectedPlayer)}
							>
								{selectedPlayer &&
								selectedPlayer.player.image ? (
									<img
										className="w-4 object-cover"
										src={selectedPlayer.player.image}
									/>
								) : (
									''
								)}

								{selectedPlayer && selectedPlayer.isKick && (
									<div className="absolute -top-1 -right-1 cursor-pointer">
										<Captain
											colorBg="#ffffff"
											colorIcon={
												choosePlatform()
													? '#35168C'
													: '#DF1737'
											}
											className="w-4 h-4"
										/>
									</div>
								)}
								{selectedPlayer.wasSubstituted && (
									<div className="absolute -bottom-1 -right-1 cursor-pointer">
										<RiArrowUpCircleFill className="w-5 h-5 text-green-500 bg-white rounded-full" />
									</div>
								)}
							</div>
							<span className="mt-1 font-bahnschrift text-center text-black text-xs font-normal leading-none">
								{selectedPlayer &&
									getLastOrFirstName(
										selectedPlayer.player.name
									)}
							</span>
						</div>
					}
					title="Pontuação"
					infoIcon="success"
					draftResult
					draftResults={scouts}
					isCapitan={selectedPlayer.isKick}
					disabled={
						scouts.length === 0 || selectedPlayer.scoutsPoints === 0
					}
				/>
			);
		});
	});

	return (
		<div className="flex flex-col gap-3">
			{draftResult.length > 0 && modalityName === 'Futebol' && (
				<SoccerField renderField={renderField} borderCustom>
					{positionRender}
				</SoccerField>
			)}
			{draftResult.length > 0 && modalityName === 'Basquete' && (
				<BaskteballField borderCustom>{positionRender}</BaskteballField>
			)}
			{draftResult.length > 0 && modalityName === 'Futebol Americano' && (
				<FootballField borderCustom>{positionRender}</FootballField>
			)}

			{draftResult &&
			draftResult.filter((item: any) => item.isReserve).length > 0 ? (
				<div className="flex flex-col gap-2">
					<div className="text-black text-lg font-normal font-bahnschrift">
						Banco de Reservas
					</div>
					<div
						className="grid w-full justify-between gap-4"
						style={{
							gridTemplateColumns: `repeat(${draftResult.reduce(
								(acc: any, item: any) => acc + item.isReserve,
								0
							)}, 1fr)`,
						}}
					>
						{draftResult
							.filter((item: any) => item.isReserve)
							.map((item: any, index: number) => {
								return (
									<Tooltip
										icon={
											<div
												key={index}
												className="flex flex-col items-center"
											>
												<span className="mb-1.5 font-bahnschrift text-center text-black text-xs font-normal leading-none">
													{item.scoutsPoints === 0
														? `${item.scoutsPoints} pts`
														: `${item.scoutsPoints} pts`}
												</span>
												<div
													className={
														'relative border-2 border-white w-12 h-12 rounded-full text-white ' +
														'font-bahnschrift shadow-lg bg-primary flex items-center justify-center text-xs'
													}
													style={getBackgroundStyle(
														item
													)}
												>
													{item.wasSubstituted && (
														<div className="absolute -bottom-1 -right-1 cursor-pointer">
															<RiArrowDownCircleFill className="w-5 h-5 text-error bg-white rounded-full" />
														</div>
													)}
												</div>

												<span className="mt-1 font-bahnschrift text-center text-black text-sm font-normal leading-none">
													{item.player.name}
												</span>
											</div>
										}
										title="Pontuação"
										infoIcon="success"
										draftResult
										draftResults={item.scouts.filter(
											(i: any) => i.points !== 0
										)}
										isCapitan={item.isKick}
										disabled={
											item.scouts.length === 0 ||
											item.scoutsPoints === 0
										}
									/>
								);
							})}
					</div>
				</div>
			) : (
				<></>
			)}
		</div>
	);
};
